
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UpcomingProgramsComponent } from './components/upcoming-programs/upcoming-programs.component';
import { TasksComponent } from './components/tasks/tasks.component';
// import { EmailPreviewComponent } from './components/email-preview/email-preview.component';
import { NotificationsComponent } from './components/notifications/notifications.component';
import { RouterModule } from '@angular/router';
import { AppMaterialModule } from '../material/material.module';
import {NgxPaginationModule} from 'ngx-pagination';
import { FormsModule } from '@angular/forms';
import{FullCalendarModule} from'ng-fullcalendar';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import { InitialLetterPipe } from './pipes/initial-letter/initial-letter.pipe';
import { MomentDatePipe } from './pipes/momentDate.pipe';

import { MyEventsCalendarComponent } from './components/my-events-calendar/my-events-calendar.component';

@NgModule({
    declarations: [
        UpcomingProgramsComponent,
        TasksComponent,
        // EmailPreviewComponent,
        NotificationsComponent,
        InitialLetterPipe,
        MomentDatePipe,
        MyEventsCalendarComponent
    ],
    imports: [
        CommonModule,
        AppMaterialModule,
        RouterModule,
        NgxPaginationModule,
        FormsModule,
        FullCalendarModule,
        MatProgressSpinnerModule,
        MatSnackBarModule
    ],
    exports: [
        UpcomingProgramsComponent,
        TasksComponent,
        // EmailPreviewComponent,
        RouterModule,
        NotificationsComponent,
        AppMaterialModule,
        NgxPaginationModule,
        FormsModule,
        FullCalendarModule,
        MatProgressSpinnerModule,
        MatSnackBarModule,
        InitialLetterPipe,
        MomentDatePipe,
        MyEventsCalendarComponent
    ]
})

export class SharedModule {}